// Handles dragging an HTML block with overflow

import { useState, useRef, useCallback } from 'react'

function useDrag () {
  const [scrolling, setScrolling] = useState({
    down: false,
    scrollLeft: 0,
    scrollTop: 0,
    x: 0,
    y: 0
  })
  const ref = useRef()

  const onMouseDown = useCallback(event => {
    setScrolling({
      down: true,
      scrollLeft: ref.current.scrollLeft,
      scrollTop: ref.current.scrollTop,
      x: event.nativeEvent.clientX,
      y: event.nativeEvent.clientY
    })
  }, [scrolling])

  const onMouseMove = useCallback(event => {
    if (scrolling.down) {
      const changeX = scrolling.x - event.nativeEvent.clientX
      const changeY = scrolling.y - event.nativeEvent.clientY

      ref.current.scrollLeft = scrolling.scrollLeft + changeX
      ref.current.scrollTop = scrolling.scrollTop + changeY

      if (changeX > 3 || changeX < -3 || changeY > 3 || changeY < -3) {
        ref.current.classList.add('dragging')
      }
    }
  }, [scrolling])

  const onDone = useCallback(() => {
    setScrolling({
      down: false,
      scrollLeft: 0,
      scrollTop: 0,
      x: 0,
      y: 0
    })
    ref.current.classList.remove('dragging')
  }, [])

  return { ref, onMouseDown, onMouseUp: onDone, onMouseMove, onMouseLeave: onDone }
}

export default useDrag
